<div class="h-full bg-white overflow-hidden relative">
    <!-- Shifts rather than overlaps when the merge panel opens, the same way
         Pin Manager does it, so the table is never hidden behind the panel. -->
    <div class="h-full overflow-y-auto transition-[margin-right] duration-300"
         [style.margin-right]="mergePanelOpen ? '360px' : '0'">
        <!-- Action Bar -->
        <!--
          No bottom border on the action bar. It is the same colour as the step
          separators below it, so it read as a divider sitting above Step 1 rather
          than as the edge of the header.
        -->
        <div class="flex items-center gap-2.5 py-4 px-7 flex-wrap">
            <button (click)="openBackDialog()"
                class="py-1.5 px-4 border-[1.5px] border-[var(--app-border)] rounded-lg text-[12px] font-semibold bg-white text-[var(--base-text-alt-dark)] cursor-pointer flex items-center gap-1.5 hover:border-[var(--primary-dark)] hover:text-[var(--primary-dark)] transition-all">
                <span class="material-icons text-[16px]">arrow_back</span> BACK
            </button>

            <span class="text-[16px] font-bold text-[var(--base-text-dark)]">Create New Interpretation</span>

            <div class="flex-1"></div>

            <!--
              SCN is created by the embedded component, which owns the fields and
              seasons it needs. Everything else goes through this page as before.
            -->
            <button (click)="isScn ? scnSteps?.create() : (selectedAnalysisTypeId === 2 ? createSoilPreparation() : createInterpretation())"
                [disabled]="isScn && !scnSteps?.canCreate"
                class="py-1.5 px-4 border-none rounded-lg text-[12px] font-semibold bg-[var(--primary-dark)] text-white cursor-pointer flex items-center gap-1.5 hover:opacity-90 transition-all disabled:bg-[#E6E6E6] disabled:text-[#C3C3C3]">
                <span class="material-icons text-[16px]">add</span> CREATE
            </button>
        </div>

        <div style="padding: 0 24px;min-height: 400px;overflow-y: auto">
                <div class="recommendation-container" style="margin: 20px 0">
                    <span class="circle-icon">1</span>

                    <div>
                        <div class="recommendation-container" style="margin-bottom: 2px">
                            <span class="step step-title">STEP 1 - Choose a Client</span>
                        </div>

                        <span class="step-description">Add one or more client who you need to do a recommendation for.</span>
                    </div>
                </div>

                <mat-form-field appearance="outline" style="width: 754px;">
                    <mat-label>Client</mat-label>
                    <mat-select [(ngModel)]="selectedClientId" (selectionChange)="selectedLabSubmissionId = null;selectedAnalysisTypeId = null;resetValues(true);">
                        <mat-option style="background-color: white!important; padding: 6px!important;">
                            <div class="select-search-container-lrg">
                                <div class="select-search-lrg">
                                    <ngx-mat-select-search placeholderLabel="Search Clients" [formControl]="clientFilterCtrl">
                            <span ngxMatSelectNoEntriesFound>
                                No entries found
                            </span>
                                    </ngx-mat-select-search>
                                </div>
                            </div>
                        </mat-option>
                        <mat-option *ngIf="isLoadingCustomers" disabled>
                            <div style="display: flex; align-items: center; gap: 8px;">
                                <mat-spinner diameter="20"></mat-spinner>
                                <span>Loading clients...</span>
                            </div>
                        </mat-option>
                        <mat-option *ngFor="let customer of filterCustomerList" [value]="customer.id">
                            {{customer.name}}
                        </mat-option>
                    </mat-select>
                </mat-form-field>

                <!--
                  Nothing past the client until there is one. Every step below needs it:
                  the submission lists are queried by customer, and the SCN field tree is
                  loaded from the customer's tenant. Showing them beforehand gave a page
                  of controls that either did nothing or, for Soil Crop Nutrition, left
                  the page looking empty below the type.

                  Hidden rather than disabled, which is how the SCN steps already behave.
                -->
                <ng-container *ngIf="selectedClientId">

                <div style="padding: 20px 0;">
                    <div class="h-px bg-[var(--app-base)]"></div>
                </div>

                <div class="recommendation-container" style="margin: 20px 0">
                    <span class="circle-icon">2</span>

                    <div>
                        <div class="recommendation-container" style="margin-bottom: 2px">
                            <span class="step step-title">STEP 2 </span>
                            <span class="step">&nbsp;- Analysis Type</span>
                        </div>

                        <span class="step-description">Which type of analysis do you want to apply to the selected samples for the interpretation?</span>
                    </div>
                </div>

                <div class="recommendation-container" style="padding-bottom: 40px;">
                    <mat-form-field style="margin-right: 20px" appearance="outline">
                        <mat-label>Analysis Type</mat-label>
                        <mat-select (selectionChange)="onAnalysisTypeChange($event.value)" [(ngModel)]="selectedAnalysisTypeId">
                            <mat-option *ngFor="let submissionType of submissionTypes" [value]="submissionType.id">
                                {{submissionType.description}}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>

                    <mat-form-field *ngIf="selectedAnalysisTypeId === 2" style="margin-right: 20px" appearance="outline">
                        <mat-label>Soil Type</mat-label>
                        <mat-select [(ngModel)]="selectedSoilTypeId" (selectionChange)="onSoilTypeChange($event.value)">
                            <mat-option *ngFor="let soilType of soilTypes" [value]="soilType.id">
                                {{soilType.name}}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>

                    <mat-form-field style="margin-right: 20px" appearance="outline" *ngIf="soilUsesLabSubmission">
                        <mat-label>Lab References</mat-label>
                        <mat-select (selectionChange)="selectedAnalysisTypeId === 2 ? loadSoilSamples() : getSoftTissueListAll(true)" [(ngModel)]="selectedLabSubmissionId">
                            <mat-option style="background-color: white!important; padding: 6px!important;">
                                <div class="select-search-container-lrg">
                                    <div class="select-search-lrg">
                                        <ngx-mat-select-search placeholderLabel="Search Lab Submissions" [formControl]="submissionFilterCtrl">
                                                            <span ngxMatSelectNoEntriesFound>
                                                                No entries found
                                                            </span>
                                        </ngx-mat-select-search>
                                    </div>
                                </div>
                            </mat-option>
                            <mat-option *ngFor="let labReference of filteredLabSubmissionList" [value]="labReference.id">
                                {{labReference.submissionId}}{{labReference?.sampleGroupName ? " - " + labReference.sampleGroupName : ""}}{{labReference?.creationDate ? " - " + (labReference.creationDate | date:"yyyy-MM-dd") : ""}}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>

<!--                    <mat-form-field style="margin-right: 20px" appearance="outline">-->
<!--                        <mat-label>Interpret By</mat-label>-->
<!--                        <mat-select>-->
<!--                            <mat-option *ngFor="let interpretation of interpretList" [value]="interpretation.id">-->
<!--                                {{interpretation.name}}-->
<!--                            </mat-option>-->
<!--                        </mat-select>-->
<!--                    </mat-form-field>-->
                </div>

                <!--
                  Choosing samples from a lab submission, which is how preparation and
                  maintenance are built. SCN is built from fields and seasons instead,
                  so this whole step is replaced for it rather than hidden piecemeal.
                -->
                <ng-container *ngIf="soilUsesLabSubmission">
                <div class="h-px bg-[var(--app-base)]"></div>

                <div class="recommendation-container" style="margin-top: 20px">
                    <span class="circle-icon">3</span>

                    <div>
                        <div class="recommendation-container" style="margin-bottom: 2px">
                            <span class="step step-title">STEP 3 </span>
                            <span class="step">&nbsp;- Choose Samples</span>
                        </div>

                        <span class="step-description">Add one or more samples</span>
                    </div>
                </div>

                <div *ngIf="dataSource?.data?.length > 0 || filteringData">
                    <div class="recommendation-container" style="justify-content: space-between;margin: 28px 0 25px 0">
                        <div class="recommendation-container" style="width: 754px">
                            <mat-form-field appearance="outline" style="margin-right: 20px" floatLabel="always">
                                <mat-label>Search</mat-label>
                                <span matPrefix>
                        <mat-icon style="padding-left: 8px">search</mat-icon>
                    </span>
                                <input matInput [(ngModel)]="searchText" (ngModelChange)="filterTable()" placeholder="Search" />
                            </mat-form-field>

<!--                            <mat-form-field appearance="outline">-->
<!--                                <mat-label>Client</mat-label>-->
<!--                                <mat-select>-->
<!--                                    <mat-option *ngFor="let fieldType of fieldTypeList" [value]="fieldType.id">-->
<!--                                        {{fieldType.name}}-->
<!--                                    </mat-option>-->
<!--                                </mat-select>-->
<!--                            </mat-form-field>-->
                        </div>

                        <div class="recommendation-container" style="gap:20px">
                            <button mat-button="outlined" class="reset-filter-btn" (click)="clearFilters()" *ngIf="isFilterBtnVisible">Clear Filters</button>

                            <mat-form-field class="recommendation-date-picker" appearance="outline">
                                <mat-label>Start Date</mat-label>
                                <input [max]="endDate" matInput [(ngModel)]="startDate" (ngModelChange)="filterDateRange()" [matDatepicker]="picker">
                                <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
                                <mat-datepicker #picker></mat-datepicker>
                            </mat-form-field>

                            <mat-form-field appearance="outline" class="recommendation-date-picker">
                                <mat-label>End Date</mat-label>
                                <input [min]="startDate" matInput [(ngModel)]="endDate" (ngModelChange)="filterDateRange()" [matDatepicker]="picker2">
                                <mat-datepicker-toggle matIconSuffix [for]="picker2"></mat-datepicker-toggle>
                                <mat-datepicker #picker2></mat-datepicker>
                            </mat-form-field>
                        </div>
                    </div>

                    <div class="table-container">
                        <table mat-table [dataSource]="dataSource" class="lab-analysis-table">

                            <ng-container matColumnDef="checkbox">
                                <th mat-header-cell *matHeaderCellDef class="samples-top-left-cell mat-cell-header">
                                    <mat-checkbox [checked]="dataSource?.data.length > 0 && selectedSamples.length === dataSource?.data.length" [indeterminate]="selectedSamples.length > 0 && dataSource?.data.length !== selectedSamples.length" class="select-all-analysis-checkbox" (change)="selectAllSamples($event)" ></mat-checkbox>
                                </th>

                                <td mat-cell class="mat-cell" *matCellDef="let element">
                                    <mat-checkbox [checked]="hasSample(element)" class="select-all-analysis-checkbox" (change)="selectSample($event, element)"></mat-checkbox>
                                </td>
                            </ng-container>

                            <ng-container matColumnDef="bagNumber">
                                <th mat-header-cell class="mat-cell-header" *matHeaderCellDef> Bag Number </th>
                                <td mat-cell class="mat-cell" *matCellDef="let element"> {{element?.bagNumber ?? '-'}} </td>
                            </ng-container>

                            <ng-container matColumnDef="farm">
                                <th mat-header-cell class="mat-cell-header" *matHeaderCellDef> Farm </th>
                                <td mat-cell class="mat-cell" *matCellDef="let element"> {{element?.farmName ?? '-'}} </td>
                            </ng-container>

                            <ng-container matColumnDef="field">
                                <th mat-header-cell class="mat-cell-header" *matHeaderCellDef> Field </th>
                                <td mat-cell class="mat-cell" *matCellDef="let element"> {{element?.fieldName ?? '-'}} </td>
                            </ng-container>

                            <ng-container matColumnDef="fieldType">
                                <th mat-header-cell class="mat-cell-header" *matHeaderCellDef> Field Type </th>
                                <td mat-cell class="mat-cell" *matCellDef="let element"> {{element?.fieldType ?? '-'}} </td>
                            </ng-container>

                            <ng-container matColumnDef="sample">
                                <th mat-header-cell class="mat-cell-header" *matHeaderCellDef> Sample </th>
                                <td mat-cell class="mat-cell" *matCellDef="let element">
                                    <span>{{element?.sampleName ?? '-'}}</span>

                                    <!-- Lab Manager sample merges.
                                         A merged group collapses to one input when the
                                         recommendation is created, so picking five samples can
                                         produce three rows. The API has sent the merge ids since
                                         merging shipped and nothing rendered them, which made a
                                         correct collapse read as samples being dropped.

                                         ONLY THE PRIMARY IS TAGGED. A member used to carry an
                                         "Into X" tag of its own, which meant a group of five put
                                         four near-identical tags down the column and said the same
                                         thing four times. The primary names the whole group, the
                                         panel lists it, and the count under the table states the
                                         outcome before anything is saved.

                                         Title rather than matTooltip: MatTooltipModule is not
                                         imported here and a tag does not justify adding it. -->
                                    <span *ngIf="element?.merge?.members?.length"
                                          class="merge-tag"
                                          [title]="mergeTitle(element)"
                                          (click)="openMergePanel(element)">Merged +{{element.merge.members.length}}</span>
                                </td>
                            </ng-container>

<!--                            <ng-container matColumnDef="sampleType">-->
<!--                                <th mat-header-cell class="mat-cell-header" *matHeaderCellDef> Sample Type </th>-->
<!--                                <td mat-cell class="mat-cell" [ngStyle]="element?.labTypeDescription ? element.labTypeDescription === 'Soft Tissue' ? {color: '#E2703B', 'font-weight': 700} : {color: '#00B47D', 'font-weight': 700} : {}" *matCellDef="let element"> {{element?.sampleType?.description ?? '-'}} </td>-->
<!--                            </ng-container>-->

                            <ng-container matColumnDef="labReference">
                                <th mat-header-cell class="mat-cell-header" *matHeaderCellDef> Lab Reference </th>
                                <td mat-cell class="mat-cell" *matCellDef="let element"> {{element?.submissionId ?? '-'}} </td>
                            </ng-container>

                            <ng-container matColumnDef="labName">
                                <th mat-header-cell class="mat-cell-header" *matHeaderCellDef> Lab Name </th>
                                <td mat-cell class="mat-cell" *matCellDef="let element"> {{element?.labName ?? '-'}} </td>
                            </ng-container>

                            <ng-container matColumnDef="dateCreated">
                                <th mat-header-cell class="mat-cell-header" *matHeaderCellDef> Date Created </th>
                                <td mat-cell class="mat-cell" *matCellDef="let element"> {{element?.creationDate ? (element.creationDate | date:'yyyy-MM-dd, hh:mm:ss') : '-'}} </td>
                            </ng-container>

                            <ng-container matColumnDef="crop">
                                <th mat-header-cell class="mat-cell-header" *matHeaderCellDef> Crop </th>
                                <td mat-cell class="mat-cell" *matCellDef="let element">
                                    <!-- Nothing is shown for an unlinked sample. The value the query
                                         returns here is a fallback guessed from the field, not this
                                         sample's crop, and showing it is what hid the problem. -->
                                    <span *ngIf="isUnlinked(element)" class="value-unknown"
                                          [title]="unknownReason(element)">Not linked</span>

                                    <div *ngIf="!isUnlinked(element) && element?.cropId">
                                        {{element?.cropDescription ?? '-'}}
                                    </div>

                                    <div (click)="openFieldDetailsDialog(element)"
                                         *ngIf="!isUnlinked(element) && !element?.cropId"
                                         class="fix-error-btn" style="margin: 0 auto;">
                                        <mat-icon>edit</mat-icon>
                                        <span>FIX</span>
                                    </div>
                                </td>
                            </ng-container>

                            <!-- The sample's own crop definition link. Driven by
                                 seasonFieldDetailId only: crop and cultivar are
                                 resolved through a server-side fallback and look
                                 populated even when the sample has no link. -->
                            <ng-container matColumnDef="definition">
                                <th mat-header-cell class="mat-cell-header" *matHeaderCellDef> Crop Definition </th>
                                <td mat-cell class="mat-cell" *matCellDef="let element">
                                    <!-- Already linked: read-only, so an existing link cannot be repointed by accident -->
                                    <span *ngIf="!isUnlinked(element)">
                                        {{element?.linkedSeasonName ?? '-'}}<span *ngIf="element?.linkedCultivar"> &middot; {{element.linkedCultivar}}</span>
                                    </span>

                                    <!-- The field has never been attached to a season, so there is
                                         nothing to link to and an empty picker would be a dead end.
                                         The dialog behind this button can attach the field to a
                                         season, and that first season_field_details row IS the
                                         first crop definition, after which the picker has options. -->
                                    <button *ngIf="isUnlinked(element) && hasNoDefinitions(element)"
                                            (click)="openFieldDetailsDialog(element)"
                                            title="This field is not in a season yet. Attach it to one to create its first crop definition."
                                            class="py-1.5 px-4 mx-auto border-[1.5px] border-[var(--app-border)] rounded-lg text-[12px] font-semibold bg-white text-[var(--base-text-alt-dark)] cursor-pointer flex items-center gap-1.5 whitespace-nowrap hover:border-[var(--primary-dark)] hover:text-[var(--primary-dark)] transition-all">
                                        <span class="material-icons text-[16px]">edit</span> SET UP SEASON
                                    </button>

                                    <mat-form-field *ngIf="isUnlinked(element) && !hasNoDefinitions(element)" appearance="outline" class="definition-select">
                                        <mat-select placeholder="Not linked"
                                                    [disabled]="linkingSampleId === element?.pinSampleId"
                                                    (selectionChange)="onDefinitionSelected(element, $event.value)">
                                            <!-- Every state says something. A blank panel is not a state:
                                                 it leaves the user unable to tell loading from broken from
                                                 genuinely empty. -->
                                            <mat-option *ngIf="definitionsLoading" [disabled]="true">
                                                Loading...
                                            </mat-option>
                                            <mat-option *ngIf="definitionsFailed" [disabled]="true">
                                                Could not load crop definitions
                                            </mat-option>
                                            <!-- No empty state here: a field with no definitions shows the
                                                 SET UP SEASON button instead of this picker, so the empty
                                                 case can no longer reach the panel. -->
                                            <!-- Bound to a plain property, never a method. A method feeding
                                                 *ngFor returns a new array every change detection pass, which
                                                 Angular reads as changed data and re-renders, which runs
                                                 change detection again. Labels are resolved at load time for
                                                 the same reason.

                                                 Ended seasons stay selectable: a sample whose season has
                                                 closed is exactly what this column exists to resolve. The
                                                 state is shown so picking one is deliberate. -->
                                            <mat-optgroup *ngFor="let group of definitionGroupsByField[element?.fieldId]"
                                                          [label]="group.label"
                                                          [class.season-ended]="group.seasonState === 'ended'"
                                                          [class.season-running]="group.seasonState === 'running'">
                                                <mat-option *ngFor="let def of group.definitions" [value]="def.id">
                                                    {{def.label}}
                                                </mat-option>
                                            </mat-optgroup>
                                        </mat-select>
                                    </mat-form-field>
                                </td>
                            </ng-container>

                            <ng-container matColumnDef="cultivar">
                                <th mat-header-cell class="mat-cell-header" *matHeaderCellDef> Cultivar </th>
                                <td mat-cell class="mat-cell" *matCellDef="let element">
                                    <!-- Same reasoning as Crop, plus a second case: a sample can be
                                         correctly linked to a definition that simply has no cultivar
                                         recorded. That is fixed on the season, not here, so the two
                                         are worded differently. -->
                                    <span *ngIf="unknownReason(element)" class="value-unknown"
                                          [title]="unknownReason(element)">
                                        {{ isUnlinked(element) ? 'Not linked' : 'No cultivar set' }}
                                    </span>
                                    <span *ngIf="!unknownReason(element)">{{element?.cultivar}}</span>
                                </td>
                            </ng-container>

                            <ng-container matColumnDef="growthStage">
                                <th mat-header-cell *matHeaderCellDef class="mat-cell-header samples-top-right-cell"> Growth Stage </th>
                                <td mat-cell class="mat-cell" *matCellDef="let element"> {{element?.growthStage ?? '-'}} </td>
                            </ng-container>


                            <ng-container matColumnDef="rockPct">
                                <th mat-header-cell *matHeaderCellDef class="mat-cell-header"> Rock % </th>
                                <td mat-cell class="mat-cell" *matCellDef="let element"> {{element?.rockPercentage ?? '-'}} </td>
                            </ng-container>

                            <ng-container matColumnDef="depth">
                                <th mat-header-cell *matHeaderCellDef class="mat-cell-header samples-top-right-cell"> Depth </th>
                                <td mat-cell class="mat-cell" *matCellDef="let element"> {{element?.sampleDepth ?? '-'}} </td>
                            </ng-container>
                            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                            <!-- The cropId half stays soft-tissue only, because soil has no crop column
                                 and no crop requirement. The unlinked half now applies to both: soil
                                 blocks on CREATE as well, so the row has to warn before the user gets
                                 there. -->
                            <tr mat-row [ngClass]="{'row-error': rowHasError(row)}" *matRowDef="let row; columns: displayedColumns;"></tr>
                        </table>
                    </div>


                    <div class="bottom-bar-container">
                        <div>
                            <span>Total Samples Selected:&nbsp;</span>
                            <!-- A plain count again. It used to explain how many
                                 recommendations a selection would really produce, which
                                 mattered while members were selectable rows and the number
                                 could shrink on save. A merged group is one row now, so the
                                 count can no longer be anything other than what it says. -->
                            <span>{{selectedSamples?.length}}</span>
                        </div>

<!--                        <mat-paginator-->
<!--                                (page)="onPaginateChange($event)"-->
<!--                                [pageSize]="pageSize"-->
<!--                                [pageIndex]="currentPage"-->
<!--                                [pageSizeOptions]="[5, 10, 20]"-->
<!--                                [showFirstLastButtons] = "true"-->
<!--                                [length]="totalElements">-->
<!--                        </mat-paginator>-->
                    </div>
                </div>

                <div class="no-data-container" *ngIf="(!dataSource?.data || dataSource?.data?.length === 0) && !filteringData">
                    <mat-icon class="no-data-icon">error_outline</mat-icon>

                    <div>
                        <div style="margin-bottom: 5px;">
                            <span style="font-size: 16px;font-weight: 700">Choose Analysis Type</span>
                        </div>
                        <span style="font-size: 14px">No data to display.</span>
                    </div>
                </div>

                    <div class="h-px bg-[var(--app-base)]"></div>
                </ng-container>

                <!--
                  The Soil Crop Nutrition steps, the same component that used to have
                  its own page. The client is already chosen above, so it runs embedded:
                  no header, no client step, and its step numbers continue from this
                  page's.
                -->
                <!--
                  Wrapped rather than styling the component element directly: a custom
                  element is display:inline by default, so padding on it would not
                  reliably hold the last season row off the bottom of the scroll area.
                -->
                <div *ngIf="isScn && selectedClientId" class="pb-10">
                    <!-- Season first. There is no embedded flag any more: this screen only ever
                         runs inside this page, and the client comes from it. -->
                    <app-create-soil-crop-nutrition
                        #scnSteps
                        [client]="selectedCustomer"
                        [stepOffset]="1">
                    </app-create-soil-crop-nutrition>
                </div>

                <ng-container *ngIf="selectedAnalysisTypeId !== null && selectedAnalysisTypeId !== 2">
                    <div class="recommendation-container" style="margin: 20px 0">
                        <span class="circle-icon">4</span>

                        <div>
                            <div class="recommendation-container" style="margin-bottom: 2px">
                                <span class="step step-title">STEP 4 </span>
                                <span class="step">&nbsp;- Choose a Norm</span>
                            </div>

                            <span class="step-description">Choose what norm type that will be applied to the selected samples above.</span>
                        </div>
                    </div>

                    <form [formGroup]="normForm">
                        <div formArrayName="norms">
                            <div *ngFor="let norm of norms.controls; let i = index">
                                <div [formGroupName]="i">
                                    <div class="recommendation-container" style="padding-bottom: 28px;width: 100%">
                                        <mat-form-field style="margin-right: 20px" appearance="outline">
                                            <mat-label>Crop {{ i + 1 }}</mat-label>
                                            <mat-select formControlName="crop">
                                                <mat-option *ngFor="let crop of cropList" [value]="crop.id">
                                                    {{crop.name}}
                                                </mat-option>
                                            </mat-select>
                                        </mat-form-field>

                                        <mat-form-field style="margin-right: 20px" appearance="outline">
                                            <mat-label>Region</mat-label>
                                            <mat-select (selectionChange)="getGrowthStageList(i, $event.value)" formControlName="region">
                                                <mat-option *ngFor="let region of regionList[i]?.regions" [value]="region.id">
                                                    {{region?.name}}
                                                </mat-option>
                                            </mat-select>
                                        </mat-form-field>

                                        <mat-form-field style="margin-right: 20px" appearance="outline">
                                            <mat-label>Sampling Period</mat-label>
                                            <mat-select formControlName="growthStage">
                                                <mat-option *ngFor="let growthStage of regionList[i]?.growthStages" [value]="growthStage?.normId">
                                                    {{growthStage?.name}}
                                                </mat-option>
                                            </mat-select>
                                        </mat-form-field>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </form>
                </ng-container>

                </ng-container>
                <!-- end of the client gate -->

            </div>
    </div>

    <!-- What a merge actually contains. The tags above say a group exists; this
         is where the samples it hides can be read. -->
    <app-merge-panel [open]="mergePanelOpen"
                     [group]="mergePanelGroup"
                     (closed)="closeMergePanel()"></app-merge-panel>
</div>
